import { getUserSettingsAsync, setUserSettingsAsync, isMigrationCompleteAsync } from "../../externalApi/PinMigrationApi";
export class WidgetPinningApi {
    async getUserSettingsAsync(storageKey) {
        return await getUserSettingsAsync(storageKey);
    }
    async setUserSettingsAsync(storageKey, pinnedWidgetsInfo) {
        await setUserSettingsAsync(storageKey, pinnedWidgetsInfo);
    }
    async isMigrationCompleteAsync(storageKey) {
        return await isMigrationCompleteAsync(storageKey);
    }
}
